<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-payment-view />

    <core-footer />

  </v-app>
</template>

<script>
export default {
  name: 'Payment',
  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CorePaymentView: () => import('../components/core/PaymentView'),
    CoreFooter: () => import('../components/core/Footer'),
  },
  data: () => ({
    expandOnHover: false,
  }),
}
</script>